import React, { PropTypes } from 'react';
import { pure } from 'recompose';
import $ from 'jquery';
import { Link } from 'react-router';
import OrderButtons from 'common/components/OrderButtons';
import TextParagraph from 'tip/components/TextParagraph';
import ImageParagraph from 'tip/components/ImageParagraph';

class ParagraphItem extends React.Component {
  static propTypes = {
    paragraph: PropTypes.object.isRequired,
    paragraphCount: PropTypes.number.isRequired,
    moveParagraphDown: PropTypes.func.isRequired,
    moveParagraphUp: PropTypes.func.isRequired,
    removeParagraph: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);

    this.moveDown = this.moveDown.bind(this);
    this.moveUp = this.moveUp.bind(this);
    this.remove = this.remove.bind(this);
  }

  componentDidMount() {
    $(this.refs.dimmer).dimmer({
      on: 'hover',
    });
  }

  moveUp() {
    const { paragraph } = this.props;
    this.props.moveParagraphUp(paragraph);
  }

  moveDown() {
    const { paragraph } = this.props;
    this.props.moveParagraphDown(paragraph);
  }

  remove() {
    const { paragraph } = this.props;
    this.props.removeParagraph(paragraph);
  }

  renderItem(paragraph) {
    return paragraph.content ? (
      <TextParagraph paragraph={paragraph} />
    ) : (
      <ImageParagraph paragraph={paragraph} />
    );
  }

  render() {
    const { paragraph, paragraphCount } = this.props;

    const iconClass = paragraph.content ? 'align left icon' : 'picture icon';

    return (
      <div className="item">
        <div className="ui small image">
          <i className={iconClass} />
        </div>
        <div className="middle aligned content" ref="dimmer">
          <div className="description">{this.renderItem(paragraph)}</div>
          <div className="ui inverted dimmer">
            <div className="content">
              <div className="center">
                {paragraph.content && (
                  <Link
                    to={`/paragraphs/${paragraph.id}`}
                    className="ui right labeled icon button"
                  >
                    <i className="edit icon" />
                    Modifier
                  </Link>
                )}
                <button
                  className="ui right labeled icon button negative"
                  onClick={this.remove}
                >
                  <i className="trash outline outline icon" />
                  Supprimer
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="ui small action">
          <OrderButtons
            canMoveDown={paragraph.order < paragraphCount}
            moveDown={this.moveDown}
            canMoveUp={paragraph.order > 1}
            moveUp={this.moveUp}
          />
        </div>
      </div>
    );
  }
}

export default pure(ParagraphItem);



// WEBPACK FOOTER //
// ./src/modules/tip/components/ParagraphItem.js